// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ptHL2","controls":"style_controls__2EUMB","coordinates":"style_coordinates__xer+3"};